module.exports = __webpack_public_path__ + "img/80ab28bbc155166bca5eb865e0c6d590.svg";